import { NgModule, Injectable } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { StateService, Transition } from '@uirouter/core';
import { ActiveFeatureService } from '@monsido/ng2/services/active-feature/active-feature.service';
import { MonUIRouterTransitionService } from '@monsido/ng2/services/ui-router-transition-service/ui-router-transition-service';

import { ApiUsersDashboardComponent } from './pages/api-users-dashboard.component';

@Injectable({ providedIn: 'root' })
export class ApiUsersAccessGuard {
    constructor (
        private activeFeatureService: ActiveFeatureService,
        private stateService: StateService,
        private monUIRouterTransitionService: MonUIRouterTransitionService,
    ) {}

    checkAccess (transition: Transition) {
        if (this.activeFeatureService.isFeatureActive('api_users')) {
            return true;
        }

        const params = transition.params();
        return this.monUIRouterTransitionService.onTransitionFinished(() => {
            return this.stateService.go('base.customer.admin_old.dashboard', params) as unknown as Promise<void>;
        });
    }
}

/**
 * API Users routing configuration for Angular.
 * This module provides routing for the API Users section with proper access control.
 * Uses Angular service-based access guard following the established pattern.
 */

const apiUsersStates = [
    // Access-controlled abstract route
    {
        name: 'base.customer.admin_old.api_users',
        url: '/api_users',
        abstract: true,
        data: {
            featureName: 'api_users',
            redirectURI: 'base.customer.admin_old.dashboard',
            sidebar: 'admin',
            title: undefined,
            htmlContent: '<div ui-view></div>',
        },
        resolve: [
            {
                token: 'apiUsersAccess',
                deps: [ApiUsersAccessGuard, Transition],
                resolveFn: (guard: ApiUsersAccessGuard, transition: Transition) =>
                    guard.checkAccess(transition),
            },
        ],
    },

    // Child routes with components
    {
        name: 'base.customer.admin_old.api_users.index',
        url: '?page_size&page',
        params: {
            page_size: { dynamic: true },
            page: { dynamic: true },
        },
        views: {
            'content@base.customer.admin_old': {
                component: ApiUsersDashboardComponent,
            },
        },
        data: {
            title: 'Acquia Web Governance - API Users',
            htmlContent: '<div ui-view></div>',
        },
    },
];

@NgModule({
    imports: [UIRouterModule.forChild({ states: apiUsersStates })],
    exports: [UIRouterModule],
})
export class ApiUsersRoutingModule { }
